module.exports = __webpack_public_path__ + "img/liqpay_logo.f9e79990.png";